module.exports = __webpack_public_path__ + "static/aikido_ki-15d3f7810a8919c87d8f5044319351dc.svg";